import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
    <NFLTemplate
      {...props}
      team="Seattle Seahawks"
      teamShort="Seahawks"
      teamId={teamIds['Seattle Seahawks']}
    />
  )
}
